import { Button as UIButton, ButtonProps as UIButtonProps } from '@lhb/ui';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useInteractionDelay } from '@lhb/utils';
import { useEffect, useState } from 'react';
type ButtonProps = Pick<
  UIButtonProps,
  'type' | 'variant' | 'icon' | 'trailingIcon' | 'leadingIcon'
> & { label?: React.ReactNode };

export function Button({
  type = 'submit',
  variant,
  label,
  icon,
  ...props
}: ButtonProps) {
  const { t } = useTranslation();
  const {
    formState: { isSubmitting, isValid },
  } = useFormContext();

  const [submitting, setSubmitting] = useState(false);
  const loading = useInteractionDelay(submitting, 300);

  useEffect(() => {
    if (isSubmitting) {
      setSubmitting(true);
    } else if (!isValid) {
      setSubmitting(false);
    }
  }, [isSubmitting, isValid]);

  label = label
    ? label
    : type === 'submit'
      ? t('OK')
      : type === 'reset'
        ? t('CANCEL')
        : t('OK');
  return (
    <UIButton
      type={type}
      disabled={loading}
      icon={icon}
      loading={loading}
      variant={
        variant || type === 'submit'
          ? 'primary'
          : type === 'reset'
            ? 'danger'
            : 'secondary'
      }
      {...props}
    >
      {label}
    </UIButton>
  );
}
